import "core-js/modules/es.number.to-fixed.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "common-nav"
  }, [_c('div', {
    staticClass: "clearfix"
  }, _vm._l(_vm.navigations, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "nav-item",
      "class": {
        active: item.value == _vm.value
      },
      style: {
        width: _vm.autoWidth ? (1 / _vm.navigations.length).toFixed(2) * 100 + '%' : null
      },
      attrs: {
        "data-growing-title": item.text
      },
      on: {
        "click": function click($event) {
          return _vm.onClick(item);
        }
      }
    }, [_c('span', {
      "class": [item.extraClass]
    }, [_vm._v(_vm._s(item.text))])]);
  }), 0)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };